<template>
  <div
    class="white-iqos"
    :class="{
      enabled,
      'shadow-1': useShadow,
      'no-overflow': noOverflow,
    }"
  >
    <slot name="header">
      <div
        class="white-iqos-header"
        v-if="title || subtitle"
      >
        <div class="header-title-container">
          <slot name="supertitle">
            <div class="header-title qrw-heading-xs bold qrw-text-content-base-primary w-100">
              <slot name="title">{{ title }}</slot>
            </div>
          </slot>

          <slot name="actions" />
        </div>
        <div
          class="qrw-paragraph-sm qrw-text-content-base-secondary"
          v-if="subtitle"
        >
          <slot name="subtitle">{{ subtitle }}</slot>
        </div>
      </div>
    </slot>

    <div
      class="white-iqos-body"
      :class="bodyClass"
      v-if="enabled && !hideBody"
    >
      <slot />
    </div>

    <slot name="footer" />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    bodyClass: {
      type: String,
      default: null
    },
    enabled: {
      type: Boolean,
      default: true
    },
    hideBody: {
      type: Boolean,
      default: false
    },
    useShadow: {
      type: Boolean,
      default: true
    },
    noOverflow: {
      type: Boolean,
      default: false
    },
    systemDependency: {
      type: String,
      default: false
    }
  }
}
</script>

<style scoped>
.white-iqos {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: var(--qrw-shadow-card-light);
  background: var(--qrw-background-base-primary);
}

.white-iqos-header {
  background: var(--qrw-background-base-secondary);
  padding: 16px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.header-title-container {
  display: flex;
  width: 100%;
  column-gap: 8px;
}

.header-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
}

.white-iqos-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.no-overflow {
  overflow: visible;
}

.no-overflow .white-iqos-header {
  border-radius: 8px 8px 0 0;
}

.no-overflow .white-iqos-body {
  border-radius: 0 0 8px 8px;
}
</style>
